export default "__VITE_ASSET__GVyFWCSy__"